import { render } from "./OpcaoMultiplaEscolha.vue?vue&type=template&id=ed527ffe&scoped=true"
import script from "./OpcaoMultiplaEscolha.vue?vue&type=script&lang=js"
export * from "./OpcaoMultiplaEscolha.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./OpcaoMultiplaEscolha.vue?vue&type=style&index=1&id=ed527ffe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed527ffe"]])

export default __exports__